var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field && _vm.error)?_c('div',{staticClass:"text-red text-xs py-1"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }